import { classnames } from '@aibees/shared/utils';
import { Alert, AlertTitle } from '@mui/material';
import Gleap from 'gleap';
import { memo } from 'react';
import * as Styled from './styles';
import type { SearchLimitAlertDialogPaidUserMessageProps as Props } from './types';

export const SearchLimitAlertDialogPaidUserMessage = memo(
  ({ className }: Props) => {
    const handleOpenContact = () => {
      Gleap.open();
    };

    return (
      <Styled.Wrapper
        className={classnames(
          'SearchLimitAlertDialogPaidUserMessage',
          className
        )}
        gap={1.5}
      >
        <Alert severity="warning" icon={false}>
          You’ve reached 100% of your daily search-to-credit limit. Access will
          reset automatically with the next daily cycle.
        </Alert>
        <Alert severity="default" icon={false}>
          <AlertTitle>Important Note</AlertTitle>
          <div style={{ display: 'inline' }}>
            Unusually high activity may trigger an account review to ensure fair
            use. If you believe this is a mistake, please{' '}
            <Styled.ContactLink onClick={handleOpenContact}>
              contact support
            </Styled.ContactLink>
            .
          </div>
        </Alert>
      </Styled.Wrapper>
    );
  }
);

SearchLimitAlertDialogPaidUserMessage.displayName =
  'SearchLimitAlertDialogPaidUserMessage';
